import { ApiType } from "@gymflow/common";
import { useQuery } from "@tanstack/react-query";

import { activityAsPublicQueryKeys } from "./activityAsPublicQueryKeys";

export async function activityCategoryListAsPublicQueryFn({
  api,
  filter,
}: {
  api: ApiType;
  filter: Parameters<ApiType["public"]["activityApi"]["findCategories"]>[0];
}) {
  const result = await api.public.activityApi.findCategories({
    ...filter,
  });
  return result.data;
}

export function useQueryActivityCategoryListAsPublic(
  {
    api,
    filter,
  }: {
    api: ApiType;
    filter: Parameters<ApiType["public"]["activityApi"]["findCategories"]>[0];
  },
  {
    enabled,
  }: {
    enabled?: boolean;
  } = {
    enabled: true,
  },
) {
  return useQuery({
    queryKey: activityAsPublicQueryKeys.categories(filter),
    queryFn: () => activityCategoryListAsPublicQueryFn({ api, filter }),
    enabled,
  });
}
